<template>
  <transition-group
    enter-active-class="animate__animated animate__fadeIn animate__faster"
    leave-active-class="animate__animated animate__fadeOut animate__faster"
  >
    <div class="overlay" :key="0">
      <div class="popUp form row d-flex p-0 pb-3">
        <em
          @click="$parent.shwConnectPopUp = !$parent.shwConnectPopUp"
          class="bi-x-lg position-sticky pr-1 d-flex justify-content-end"
          style="top: 7px"
        ></em>
        <div class="col-md-6 overflow-hidden">
          <div>
            <div class="d-flex justify-content-between align-items-center">
              <v-card-title> API: </v-card-title>
              <div>
                <v-btn
                  class="mr-3 change-btn act-btn"
                  style="height: 25px !important; width: fit-content !important"
                  color="primary"
                  elevation="2"
                  x-small
                  @click="
                    selectedType = 'api';
                    shwChangeGeo = true;
                  "
                  >Change Geo</v-btn
                >
                <v-btn
                  class="mr-3 add-btn act-btn"
                  style="height: 25px !important; width: fit-content !important"
                  color="primary"
                  elevation="2"
                  x-small
                  @click="
                    selectedType = 'api';
                    shwBundlePopUp = true;
                  "
                  >ADD NEW API BUNDLE</v-btn
                >
              </div>
            </div>
            <v-data-table
              :headers="headers"
              :items="apiConnections"
              :loading="
                apiConnections.length === 0 || apiConnections.length > 0
                  ? false
                  : true
              "
              :sort-by="['id']"
              :sort-desc="[false]"
              hide-default-footer
              disable-pagination
              dense
              class="elevation-1"
              style="
                height: 225px;
                overflow-y: auto;
                white-space: nowrap;
                overflow-x: hidden;
              "
              :items-per-page="-1"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <div
                  class="
                    d-flex
                    flex-row
                    py-1
                    justify-content-between
                    align-items-center
                    w-100
                  "
                  style="cursor: pointer"
                >
                  <button
                    class="btn btn-sm btn-success mr-2"
                    style="color: #fff !important; width: 58px"
                    @click="
                      shwQuestion = true;
                      selectedConnection = item.pivot.connection_id;
                      selectedTypeConnection = 'api'
                    "
                  >
                    {{ item.pivot.type === "master" ? "TRUE" : "FALSE" }}
                  </button>
                  <div
                    @click="
                      unBind(
                        $route.params.id,
                        item.pivot.connection_id,
                        {},
                        item,
                        item.type
                      )
                    "
                  >
                    <button class="btn btn-sm btn-warning">Unbind</button>
                  </div>
                </div>
              </template>
            </v-data-table>
          </div>
          <div>
            <div class="d-flex justify-content-between align-items-center">
              <v-card-title> Database: </v-card-title>
              <div>
                <v-btn
                  class="mr-3 change-btn act-btn"
                  style="height: 25px !important; width: fit-content !important"
                  color="primary"
                  elevation="2"
                  x-small
                  @click="
                    selectedType = 'db';
                    shwChangeGeo = true;
                  "
                  >Change Geo</v-btn
                >
                <v-btn
                  class="mr-3 add-btn act-btn"
                  color="primary"
                  style="height: 25px !important; width: fit-content !important"
                  elevation="2"
                  x-small
                  @click="
                    selectedType = 'db';
                    shwBundlePopUp = true;
                  "
                  >ADD NEW DB BUNDLE</v-btn
                >
              </div>
            </div>
            <v-data-table
              :headers="headers"
              :items="dbConnections"
              :loading="
                dbConnections.length === 0 || dbConnections.length > 0
                  ? false
                  : true
              "
              :sort-by="['id']"
              :sort-desc="[false]"
              hide-default-footer
              disable-pagination
              dense
              class="elevation-1"
              style="
                height: 225px;
                overflow-y: auto;
                white-space: nowrap;
                overflow-x: hidden;
              "
              :items-per-page="-1"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <div
                  class="
                    d-flex
                    flex-row
                    py-1
                    justify-content-between
                    align-items-center
                    w-100
                  "
                  style="cursor: pointer"
                >
                  <button
                    class="btn btn-sm btn-success mr-2"
                    style="color: #fff !important; width: 58px"
                    @click="
                      shwQuestion = true;
                      selectedConnection = item.pivot.connection_id;
                      selectedTypeConnection = 'db';
                    "
                  >
                    {{ item.pivot.type === "master" ? "TRUE" : "FALSE" }}
                  </button>
                  <div
                    @click="
                      unBind(
                        $route.params.id,
                        item.pivot.connection_id,
                        {},
                        item,
                        item.type
                      )
                    "
                  >
                    <button class="btn btn-sm btn-warning">Unbind</button>
                  </div>
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
        <Question
          v-if="shwQuestion"
          @confirmed="isConfirmed"
          @notConfirmed="shwQuestion = false"
          @didClose="shwQuestion = false"
          title="Are you sure?"
          text="You wiil change the 'master'. It is extremely important."
          confirmButtonText="Change"
          cancelButtonText="Cancel"
          isConfirmedTitle="Changed"
          isConfirmedText="You changed the 'master'."
          dismissTitle="Cancelled"
          dismissText=""
          confirmButtonClasses="btn btn-success"
          cancelButtonClasses="btn btn-danger"
          successIcon="success"
          errorIcon="error"
        />
      </div>
    </div>
    <AddNewBundle :selectedType="selectedType" :key="1" v-if="shwBundlePopUp" />
    <ChangeGeo v-if="shwChangeGeo" :selectedType="selectedType" :key="2" />
  </transition-group>
</template>

<script>
import AddNewBundle from "../../popUps/connections/AddNewBundle.vue";
import Connections from "../../../apis/Connections";
import Question from "../../popUps/Question.vue";
import ChangeGeo from "./ChangeGeo.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "ConnectionSettings",
  components: {
    ChangeGeo,
    Question,
    AddNewBundle,
  },
  data() {
    return {
      selectedTypeConnection: "",
      selectedConnection: null,
      shwQuestion: false,
      shwChangeGeo: false,
      headers: [
        { text: "Id", value: "id", align: "left" },
        {
          text: "Name",
          value: "name",
          align: "left",
        },
        {
          text: "Attribute",
          value: "attribute",
          align: "left",
          sortable: false,
        },
        { text: "Number", value: "number", align: "center", sortable: false },
        { text: "Tag", value: "tag", align: "center", sortable: false },
        {
          text: "Datacenter",
          value: "datacenter",
          align: "center",
          sortable: false,
        },
        {
          text: "Activeness",
          value: "is_active",
          align: "center",
          sortable: false,
        },
        {
          text: "Region",
          value: "region",
          sortable: false,
          align: "center",
        },

        // {
        //   text: "Datacenter",
        //   value: "datacenter",
        //   sortable: false,
        //   align: "center",
        // },
        // { text: "Config", value: "config", align: "center" },
        // { text: "Activeness", value: "is_active", align: "center" },
        { text: "Master", value: "actions", align: "left", sortable: false },
      ],
      selectedType: "",
      shwBundlePopUp: false,
      // dbConnections: [],
      // apiConnections: [],
    };
  },
  computed: {
    ...mapState({
      dbConnections: (state) => state.connections.db_connections,
      apiConnections: (state) => state.connections.api_connections,
    }),
  },
  mounted() {
    this.getDBConnections(this.$route.params.id);
    this.getAPIConnections(this.$route.params.id);
  },
  methods: {
    ...mapActions([
      "getDBConnections",
      "getAPIConnections",
      "changeMasterDB",
      "unBindConnectionToDomain",
    ]),
    isConfirmed() {
      this.changeMasterConnection(
        this.$route.params.id,
        this.selectedConnection
      );
    },
    unBind(dmn_id, connection_id, condition, selectedObj, selectedType) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, unbind it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
          showClass: {
            popup: "animate__animated animate__fadeIn animate__faster",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOut animate__faster",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire({
              title: "Unbound!",
              text: "Your bundle has been unbound.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });

            this.unBindConnectionToDomain([
              dmn_id,
              connection_id,
              condition,
              selectedObj,
              selectedType,
            ]);
          } else if (
            result.dismiss === swalWithBootstrapButtons.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire({
              showClass: {
                popup: "animate__animated animate__fadeIn animate__faster",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOut animate__faster",
              },
              title: "Cancelled!",
              text: "Bundle is safe :)",
              icon: "error",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
    },
    changeMasterConnection(dmn_id, connection_id) {
      if (this.selectedTypeConnection == "db") {
        Connections.changeMasterDomainConnectionDB(dmn_id, connection_id).then(
          () => {
            for (let connection of this.dbConnections) {
              if (connection.pivot.connection_id === connection_id) {
                connection.pivot.type = "master";
              } else if (connection.pivot.connection_id !== connection_id) {
                connection.pivot.type = "slave";
              }
            }
          }
        )
      } else if (this.selectedTypeConnection == "api") {
        Connections.changeMasterDomainConnectionAPI(dmn_id, connection_id).then(
          () => {
            for (let connection of this.apiConnections) {
              if (connection.pivot.connection_id === connection_id) {
                connection.pivot.type = "master";
              } else if (connection.pivot.connection_id !== connection_id) {
                connection.pivot.type = "slave";
              }
            }
          })
      }
    }
  },
};
</script>